import { useMemo } from 'react'
import { Box } from '@mui/material'
import { navigate } from '@reach/router'
import { t } from 'i18next'
import * as routes from 'src/constants/routes'
import { useTipoMensajeContext } from 'src/contexts/TipoMensajeContext'
import useEscrito from 'src/hooks/useEscrito'

export default function OpenEscrito(): JSX.Element {
  const { setFormDocument } = useEscrito()
  const { getRoute: getEscritoRoute } = useTipoMensajeContext()

  const queryParams = useMemo(() => {
    const params = new URLSearchParams(window.location.search)
    return {
      idTipoEscrito: params.get('idTipoEscrito'),
      idDocument: params.get('idDocument'),
      idEntity: params.get('idEntity'),
      idEntityType: params.get('idEntityType'),
      idCompany: params.get('idCompany')
    }
  }, [])

  const redirectToEscrito = (tipoEscritoId: number) => {
    const route = getEscritoRoute(tipoEscritoId)
    navigate(routes.ESCRITOS_LEXNET(route))
  }

  const { idTipoEscrito, idDocument, idEntity, idEntityType, idCompany } = queryParams

  if (idTipoEscrito && idDocument) {
    setFormDocument(
      Number(idTipoEscrito),
      Number(idDocument),
      Number(idEntity),
      Number(idEntityType),
      Number(idCompany)
    )
  }

  redirectToEscrito(Number(idTipoEscrito))

  return (
    <>
      <Box component="div">{t('views.redirect_to_escrito')}</Box>
    </>
  )
}
